module.exports = __webpack_public_path__ + "static/img/logo_jt_4.282141f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_4.png
// module id = cKaj
// module chunks = 0